import { render } from "./LocalLoader.vue?vue&type=template&id=abde9fe2&scoped=true"
const script = {}

import "./LocalLoader.vue?vue&type=style&index=0&id=abde9fe2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abde9fe2"]])

export default __exports__